<template>
  <div class="page-wrapper">
    <div class="container">
      <!-- content -->
      <div class="content">
        <div class="row">
          <div class="col-md-12">
            <!-- search-content -->
            <div class="container search-content">
              <h2>Search for Colleges</h2>
            </div>
            <div class="dynamic-search-container-college">
              <div class="mobile-filter">
                <div class="filter-button" @click="showDrawer">
                  <a-icon type="filter" />
                  Filter Table
                </div>
                <a-drawer
                  class="filter-modal menu-modal custom-modal"
                  placement="right"
                  :visible="visible"
                  @close="onClose"
                >
                  <div class="filter-title">
                    Filter College Search
                  </div>
                  <BaseFilter
                    class="collapse in"
                    :config="searchConfig"
                    @submit="handleFilterApply"
                    @on-filter-change="handleFilterChange"
                  />
                </a-drawer>
              </div>
              <BaseFilter
                class="collapse in"
                :config="searchConfig"
                @on-filter-change="handleFilterChange"
                @submit="handleFilterApply"
              />
            </div>
          </div>
        </div>
        <BaseTable
          class="margin-t-1"
          :columns="columns"
          :data="colleges"
          :pagination="paginationOptions"
          @change="handleTableChange"
          :loading="collegesLoading"
          :show-zero="collegesMeta.total === 0"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import generateImageUrl from "@/utils/generate-image-url";
import { College } from "@/models";
import { SEARCH_COLLEGE_INDEX_TABLE_COLUMNS } from "@/utils/columns.js";

const STORE_KEY = "collegeStore";
const FAVOURITE_STORE_KEY = "favouriteStore";

const COLLEGE_SEARCH_FIELDS =
  "collegeName, state, city, logo, division, gpaRequired, schoolTuition, schoolType, schoolEnrollment";

export default {
  data() {
    return {
      searchConfig: College.filterConfig(),
      paginationLimit: 40,
      currentPage: 1,
      visible: false,
      searchFilters: {}
    };
  },
  mounted() {
    this.dispatcher();
  },
  computed: {
    profileId() {
      return College.profileId();
    },
    ...mapGetters({
      colleges: `${STORE_KEY}/colleges`,
      collegesMeta: `${STORE_KEY}/collegesMeta`,
      collegesLoading: `${STORE_KEY}/collegesLoading`
    }),
    columns() {
      return [
        {
          title: "Fav",
          dataIndex: "favourite",
          customRender: (_text, rowData, _index) => {
            const h = this.$createElement;
            const className = rowData.favC ? "icon-filled" : "";
            const iconTheme = rowData.favC ? "filled" : "outlined";
            return (
              <BaseButton
                type="link"
                size="large"
                class={className}
                on-click={event => this.handleFavouriteClick(event, rowData)}
              >
                <BaseIcon type="star" theme={iconTheme} />
              </BaseButton>
            );
          }
        },
        {
          title: "Name",
          dataIndex: "collegeName",
          customRender: (_text, rowData) => {
            const h = this.$createElement;
            return (
              <a
                href={this.hrefRoute(rowData.id)}
                class="text-black d-flex align-center"
                target="_blank"
                on-click={ event => this.handleCollegeClick(event, rowData) }
              >
                <BaseImageWrapper
                  class="margin-r-10"
                  size={45}
                  imageUrl={generateImageUrl(rowData.logo)}
                  wrapperStyle="circle"
                  name={rowData.collegeName}
                />
                {rowData.collegeName}
              </a>
            );
          }
        },
        ...SEARCH_COLLEGE_INDEX_TABLE_COLUMNS,
        {
          title: "Tuition",
          key: "schoolTuition",
          dataIndex: "schoolTuition",
          customRender: (_text, rowData) => {
            const h = this.$createElement;
            return (
              <span>
                {rowData.schoolTuition === "-"
                  ? `${rowData.schoolTuition}`
                  : `$${rowData.schoolTuition}`}
              </span>
            );
          }
        },
        {
          title: "Enrollment",
          key: "schoolEnrollment",
          dataIndex: "schoolEnrollment"
        }
      ];
    },
    paginationOptions() {
      return {
        total: this.collegesMeta.total || 10,
        current: this.currentPage || 1,
        simple: true,
        pageSize: 40
      };
    }
  },
  methods: {
    async handleCollegeClick(e, rowData) {
      e.stopImmediatePropagation()
      await this.$store.dispatch(`${STORE_KEY}/updateViewCount`, { id: rowData.id })
    },
    hrefRoute(id) {
      return `/${this.profileId}/college_profile/${id}/summary`;
    },
    handleTableChange(pagination) {
      this.dispatcher(pagination.current);
    },
    dispatcher(page = 1) {
      this.currentPage = page;
      this.$store.dispatch(`${STORE_KEY}/getColleges`, {
        fields: COLLEGE_SEARCH_FIELDS,
        limit: this.paginationLimit,
        page: this.currentPage,
        ...this.searchFilters
      });
    },
    handleFilterChange(searchFilters) {
      this.searchFilters = searchFilters;
      this.searchFilters = this.searchFilters["academicSpecialities"]
        ? {
            ...this.searchFilters,
            academicSpecialities:
              this.searchFilters["academicSpecialities"].join(",") || null
          }
        : { ...this.searchFilters, academicSpecialities: null };
    },
    handleFilterApply() {
      this.dispatcher();
      this.visible = false;
    },
    handleRowClick(rowData) {},
    goToRoute(route) {
      this.$router.push(route);
    },
    toggleSearchContainer() {
      this.showAdvancedFilters = !this.showAdvancedFilters;
    },

    async handleFavourite(rowData){
      if (rowData.favC) {
        await this.$store.dispatch(`${FAVOURITE_STORE_KEY}/deleteFavourite`, {
          favBy: College.profileId(),
          favTo: rowData.Id
        });
        this.$store.dispatch(`${STORE_KEY}/unsetFavourite`, rowData.Id);
        return;
      }
      await this.$store.dispatch(`${FAVOURITE_STORE_KEY}/createFavourite`, {
        favBy: College.profileId(),
        favTo: rowData.Id,
        typeFav: "college"
      });
      this.$store.dispatch(`${STORE_KEY}/setFavourite`, rowData.Id);
    },
    async handleFavouriteClick(event, rowData) {
      event.stopImmediatePropagation();
      const local_profile_id = localStorage.getItem("profile-id");
      const route_profile_id = this.$route.params.profileId;
      const currentUser = localStorage.getItem("user-permissions");
      if(currentUser === '"player"'){
        this.handleFavourite(rowData);
      }else{
        if(local_profile_id === route_profile_id){
          this.handleFavourite(rowData);
        }else{
           this.$notification.error({
              message: "Error",
              description:"Favourite Error"
            });
        }
      }
    },

    showDrawer() {
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    handleOk(e) {
      this.visible = false;
    }
  }
};
</script>
<style lang="sass">
.icon-filled
  .anticon
    color: golden
  .disabled
    pointer-events: none
    opacity: 0.6
.dynamic-search-container-college
  .filter-button
    display: none
    justify-content: center
    align-items: center
    width: 100%
    margin: 0 auto 20px
    border: 1px solid #b0b0b0
    border-radius: 3px
    padding: 8px 30px
    color: #4a4a4a
    font-weight: 500
    font-size: 15px
    .anticon
      margin-right: 8px
  form
    display: grid
    grid-template-columns: repeat(11, 1fr)
    .ant-form-item
      margin-bottom: 5px
    .grid-component
      padding-right: 10px
    .grid-component-wrapper-one
      grid-column-start: 1
      grid-column-end: 4
      width: 67%
      grid-row-start: 1
    .grid-component-wrapper-two
      grid-column-start: 3
      grid-column-end: 6
      grid-row-start: 1
      width: 95%
    .grid-component-wrapper-three
      grid-column-start: 2
      grid-column-end: 13
      grid-row-start: 3
      width: 83%
    .grid-component-wrapper-four
      grid-column-start: 6
      grid-column-end: 9
      grid-row-start: 1
    .grid-component-wrapper-five
      grid-column-start: 9
      grid-row-start: 1
      grid-column-end: 11
    .grid-component-wrapper-six
      grid-column-start: 3
      grid-column-end: 5
      grid-row-start: 2
    .grid-component-wrapper-seven
      grid-row-start: 2
      grid-column-start: 5
      grid-column-end: 7
    .grid-component-wrapper-eight
      grid-row-start: 2
      grid-column-start: 7
      grid-column-end: 9
    .grid-component-wrapper-nine
      grid-row-start: 5
      grid-column-start: 3
      grid-column-end: 6
      padding-left: 30px
      padding-right: 15px
      .ant-col
        width: 100%
    .grid-component-wrapper-ten
      grid-row-start: 5
      grid-column-start: 6
      grid-column-end: 9
      padding-right: 30px
      padding-left: 15px
      .ant-col
        width: 100%
    .grid-component-wrapper-eleven
      grid-row-start: 6
      grid-column-start: 5
      grid-column-end: 7
      padding-left: 10px

@media only screen and (max-width: 575px)
  .filter-modal
    .ant-drawer-body
      padding: 75px 40px 100px
      .filter-title
        width: fit-content
        font-size: 18px
        color: #d73228
        font-weight: 700
        text-transform: uppercase
        margin-bottom: 35px
        padding-bottom: 15px
        position: relative
        &::before
          position: absolute
          content: ""
          width: 50px
          height: 2px
          background: #d73228
          left: 0
          bottom: 0
      .grid-component
        margin-bottom: 15px !important
        .ant-form-item-label
            padding: 0
            label
              text-align: left
              margin: 0
        &.checkbox-form-item
          align-items: center
          .ant-form-item-label
            width: 115px
      .grid-component-wrapper-eleven
        width: 100%
        text-transform: uppercase
  .dynamic-search-container-college
    .filter-button
      display: flex
    form
      display: none !important
</style>
